import React from 'react'
import AnimatedLogo from '../AnimatedLogo'
import './LoadingScreen.css'

export default function LoadingScreen({
  customLogo = null,
  spinnerColor = null,
  message = 'Wird geladen …',
}) {
  return (
    <div
      className="vote-loading-screen"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="vote-loading-screen__content">
        <AnimatedLogo
          customLogo={customLogo}
          spinnerColor={spinnerColor}
        />
        <p className="vote-loading-screen__message">{message}</p>
      </div>
    </div>
  )
}
